import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class MassCommunicationService {
   apiUrl = environment.LargeapiUrl;

  constructor(private http: HttpClient) {}

  saveTemplate(payload: any): Observable<any> {
    const url = `${this.apiUrl}/v4/communication/createTemplate`;
    return this.http.post(url, payload);
  }
  updateTemplate(payload: any): Observable<any> {
        const url = `${this.apiUrl}/v4/communication/updateTemplate`;
        return this.http.post(url, payload);
    }

    getTemplates(msid): Observable<any> {
        let dbInstance = environment.environmentName != 'Prod' ? environment.environmentName : ''
        const url = `${this.apiUrl}/v4/communication/getTemplate?MSID=${msid}&env=${environment.environmentName}&dbInstance=${dbInstance}`;
        return this.http.get(url);
    }

    getCommunityList(): Observable<any> {
        let dbInstance = environment.environmentName != 'Prod' ? environment.environmentName : ''
        const url = `${this.apiUrl}/v4/communication/getCommunity?dbInstance=${dbInstance}`;
        return this.http.get(url);
    }
    createTemplate(payload: any): Observable<any> {
        const url = `${this.apiUrl}/v4/communication/createTemplate`;
        return this.http.post(url, payload);
    } 

    
    sendEmail(payload: any): Observable<any> {
        console.log('payload: ', payload);
        const url = `${this.apiUrl}/v4/communication/sendEmail`;
        const formData: FormData = new FormData();

        const headers = new HttpHeaders({
            'Content-Type': ''
            });
            const options = {
            headers: headers
            }

        // Append text fields
        Object.keys(payload).forEach(key => {
            if (key !== 'attachments') {
            formData.append(key, (payload as any)[key]);
            }
        });
        
        // Append each file under the same field name: 'attachments'
        if (payload.attachments && Array.isArray(payload.attachments)) {
            payload.attachments.forEach((file: File) => {
            // include filename to preserve original name
            formData.append('attachments', file, file.name);
            });
        }
        return this.http.post(url, formData, options);
    }
}
